module.exports = __webpack_public_path__ + "static/media/ambient_ocean_audio.47952288.mp4";